import 'stylesheets/base.scss';

import React, { Component, PropTypes }  from 'react';
import { connect }                      from 'react-redux';
import { IntlProvider }                 from 'react-intl';
import moment                           from 'moment';

import ProgressBar              from 'routes/app/components/ProgressBar';
import 'app/lib/materialize';
import PureRenderComponent      from 'app/lib/PureRenderComponent';
import { settings }             from 'app/globals';
import I18nRepository           from 'modules/app/repositories/I18nRepository';

class Intl extends PureRenderComponent {

    static propTypes = {
        children: PropTypes.element,
        locale: PropTypes.oneOf(settings.supportedLocales)
    };

    constructor(props) {
        super(props);

        this.state = {
            messages: {},
            messagesLoading: true
        };

        this.getLanguageData(props.locale);
    }

    getLanguageData(locale) {
        return I18nRepository.getTranslations(locale).then(messages => {
            moment.locale(locale);
            this.setState({
                messages: messages,
                messagesLoading: false
            });
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.locale !== this.props.locale) {
            this.getLanguageData(nextProps.locale);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // Prevent re-render when locale change, the component has to wait on data load (= 'getLanguageData')
        // before re-rendering the component.
        return nextProps.locale === this.props.locale;
    }

    render() {
        let {locale, children, ...props} = this.props;

        if (this.state.messagesLoading) {
            return <div className="app-loader"><ProgressBar /></div>;
        }

        return (
            <IntlProvider locale={locale} messages={this.state.messages}>
                {children}
            </IntlProvider>
        );

    }

}

function mapStateToProps(state) {
    return {
        locale: state.get('profile').get('locale')
    };
}

export const IntlContainer = connect(mapStateToProps)(Intl);

export default Intl;
